(function () {
    const DREAME_LOYALTY_SHOPS = ['us', 'vacuummop', 'beauty', 'air', 'yardcare'];
    const sodiumReady = import('https://cdn.jsdelivr.net/npm/libsodium-wrappers@0.7.15/+esm')
        .then(async function (module) {
            const sodium = module.default;
            await sodium.ready;
            return sodium;
        });
    //邮箱加密
    async function encryptLoyaltyEmail(email) {
        if (!email) {
            throw new Error('Email is required');
        }
        const sodium = await sodiumReady;
        const publicKeyBase64 = 'aOWlfJ5KPW92bcBlmZ1dALYaLOho_7VeJYJxsoFaADE';
        if (!publicKeyBase64) {
            throw new Error('Loyalty public key is not configured');
        }
        const variant = sodium.base64_variants.URLSAFE_NO_PADDING;
        const publicKey = sodium.from_base64(
            publicKeyBase64,
            variant
        );
        const message = sodium.from_string(
            String(email).trim()
        );
        const encryptedBytes = sodium.crypto_box_seal(
            message,
            publicKey
        );

        return sodium.to_base64(
            encryptedBytes,
            variant
        );
    }
    // 根据customer.email获取用户信息
    async function fetchUserInfo(email, storeId) {
        if (!DREAME_LOYALTY_SHOPS.includes(storeId)) {
            throw new Error('Loyalty site flag is required');
        }

        const emailEnc = await encryptLoyaltyEmail(email);
        const params = new URLSearchParams({
            flag: storeId,
            email_enc: emailEnc
        });
        const response = await fetch(`/apps/loyalty/customers?${params.toString()}`,
            {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json'
                }
            }
        );
        const data = await response.json();
        if (!response.ok) {
            throw new Error(
                data?.error?.message ||
                `Loyalty request failed: ${response.status}`
            );
        }
        return data;
    }

    function normalizeStoreResult(result) {
        if (!result.success) {
            return { ...result, state: 'check_failed', points: null, customer: null };
        }

        const customer = Array.isArray(result.data?.customers)
            ? result.data.customers[0]
            : null;

        if (!customer) {
            return { ...result, state: 'account_not_found', points: 0, customer: null };
        }

        const points = Number(customer.points_balance) || 0;
        return {
            ...result,
            state: points > 0 ? 'ready' : 'no_points',
            points: points,
            customer: customer
        };
    }

    function updateMainStoreBalance(result) {
        const banner = document.querySelector('.points-transfer-banner-section[data-store-id]');
        if (!banner || result.storeId !== banner.dataset.storeId) return;

        const customerId = result.customer?.id;
        if (customerId !== undefined && customerId !== null && customerId !== '') {
            banner.dataset.customerId = String(customerId);
        } else {
            delete banner.dataset.customerId;
        }

        const balance = banner.querySelector('.points-balance-num');
        if (balance) balance.textContent = result.points?.toLocaleString('en-US') || '0';
    }

    function applyStoreResult(result) {
        const normalized = normalizeStoreResult(result);
        updateStoreState(normalized.storeId, normalized);
        updateMainStoreBalance(normalized);
        return normalized;
    }

    function setAllSourceCardsState(state) {
        document.querySelectorAll('.pts-card[data-store-id]').forEach(function (card) {
            updateStoreState(card.getAttribute('data-store-id'), {
                state: state,
                points: 0
            });
        });
    }
    // 根据customer.email获取用户信息并更新卡片状态
    function loadStorePoints(email, storeId) {
        return fetchUserInfo(email, storeId)
            .then(function (data) {
                return applyStoreResult({
                    success: true,
                    storeId: storeId,
                    data: data,
                    error: null
                });
            })
            .catch(function (error) {
                console.error('[Points Transfer] Store lookup failed:', storeId, error);
                return applyStoreResult({
                    success: false,
                    storeId: storeId,
                    data: null,
                    error: {
                        message: error?.message || 'Loyalty request failed'
                    }
                });
            });
    }

    function loadAllStorePoints(email) {
        DREAME_LOYALTY_SHOPS.forEach(function (storeId) {
            loadStorePoints(email, storeId);
        });
    }
    // 更新卡片状态
    function updateStoreState(storeId, data) {
        const card = document.querySelector('.pts-card[data-store-id="' + storeId + '"]');
        if (!card) return;

        const state = data.state || 'check_failed';
        const points = Number(data.points) || 0;
        const customerId = data.customer?.id;
        card.setAttribute('data-state', state);
        card.dataset.points = String(points);
        if (customerId !== undefined && customerId !== null && customerId !== '') {
            card.dataset.customerId = String(customerId);
        } else {
            delete card.dataset.customerId;
        }
        card.className = card.className.replace(/\bpts-card-\S+/g, '') + ' pts-card-' + state;

        card.querySelectorAll('[data-state-badge]').forEach(function (badge) {
            badge.hidden = badge.getAttribute('data-state-badge') !== state;
        });
        card.querySelectorAll('[data-state-content]').forEach(function (content) {
            content.hidden = content.getAttribute('data-state-content') !== state;
        });

        const pointsElement = card.querySelector('[data-points-value]');
        if (pointsElement) {
            pointsElement.textContent = points.toLocaleString('en-US');
        }
    }


    // Modal Operations & Input Validation
    document.addEventListener('DOMContentLoaded', function () {
        const customerEmail = window.PointsTransferCustomer?.email;

        if (!customerEmail) {
            setAllSourceCardsState('account_not_found');
        } else {
            setAllSourceCardsState('no_points');
            loadAllStorePoints(customerEmail);
        }
        // 重试按钮点击事件
        document.body.addEventListener('click', function (e) {
            const retryBtn = e.target.closest('.pts-btn-retry[data-action="retry"]');
            console.log('Retry button clicked:---', retryBtn);
            if (!retryBtn) return;

            e.preventDefault();
            const card = retryBtn.closest('.pts-card');
            const storeId = card && card.getAttribute('data-store-id');
            const email = window.PointsTransferCustomer?.email;
            if (!storeId || !email || !DREAME_LOYALTY_SHOPS.includes(storeId)) return;
            retryBtn.disabled = true;
            loadStorePoints(email, storeId).finally(function () {
                retryBtn.disabled = false;
            });
        });

        var modalBackdrop = document.querySelector('.pts-modal-backdrop');
        if (!modalBackdrop) return;

        var fromStoreEl = document.getElementById('PtsModalFromStore');
        var toStoreEl = document.getElementById('PtsModalToStore');
        var availStoreEl = document.getElementById('PtsModalAvailableStore');
        var availValEl = document.getElementById('PtsModalAvailableVal');
        var inputEl = document.getElementById('PtsModalInput');
        var errorMsgEl = document.getElementById('PtsModalError');
        var confirmBtnEl = document.getElementById('PtsModalConfirmBtn');

        var currentAvailPoints = 0;
        var currentSourceStoreId = '';
        var currentSourceCustomerId = '';
        var currentDestinationStoreId = '';
        var currentDestinationCustomerId = '';
        var confirmButtonText = confirmBtnEl ? confirmBtnEl.textContent : '';

        // 打开弹窗
        document.body.addEventListener('click', function (e) {
            var btn = e.target.closest('.pts-btn-ready');
            if (btn) {
                e.preventDefault();
                var card = btn.closest('.pts-card');
                if (!card) return;

                // Extract From Store Name
                var storeNameEl = card.querySelector('.pts-store-name');
                var sourceStore = storeNameEl ? storeNameEl.textContent.trim() : 'Source Store';

                // Read the raw balance stored when the API result was applied.
                currentAvailPoints = Number(card.dataset.points) || 0;
                currentSourceStoreId = card.dataset.storeId || '';
                currentSourceCustomerId = card.dataset.customerId || '';
                var sourcePointsText = currentAvailPoints.toLocaleString(document.documentElement.lang || undefined);

                // Destination is always the current store configured in the banner.
                var banner = document.querySelector('.points-transfer-banner-section[data-store-id]');
                currentDestinationStoreId = banner ? banner.dataset.storeId || '' : '';
                currentDestinationCustomerId = banner ? banner.dataset.customerId || '' : '';
                var mainStoreTitleEl = banner && banner.querySelector('.points-store-title');
                var destStore = mainStoreTitleEl ? mainStoreTitleEl.textContent.trim() : '';

                // Populate Modal Elements
                if (fromStoreEl) fromStoreEl.textContent = sourceStore;
                if (toStoreEl) toStoreEl.textContent = destStore;
                if (availStoreEl) availStoreEl.textContent = sourceStore;
                if (availValEl) availValEl.textContent = sourcePointsText + ' Points';

                // Reset Input State
                if (inputEl) {
                    inputEl.value = '';
                    inputEl.classList.remove('pts-input-has-error');
                }
                if (errorMsgEl) errorMsgEl.style.display = 'none';
                if (confirmBtnEl) confirmBtnEl.disabled = true;

                // Show Modal
                modalBackdrop.classList.add('pts-modal-active');
                modalBackdrop.setAttribute('aria-hidden', 'false');
                if (inputEl) setTimeout(function () { inputEl.focus(); }, 100);
            }
        });

        // Close Modal Handler
        function closeModal() {
            modalBackdrop.classList.remove('pts-modal-active');
            modalBackdrop.setAttribute('aria-hidden', 'true');
        }

        // Close on [data-close-modal] buttons
        var closeBtns = modalBackdrop.querySelectorAll('[data-close-modal]');
        closeBtns.forEach(function (b) {
            b.addEventListener('click', closeModal);
        });

        // Close on backdrop click (outside dialog)
        modalBackdrop.addEventListener('click', function (e) {
            if (e.target === modalBackdrop) {
                closeModal();
            }
        });

        // Only positive integers up to the source-store balance are valid.
        if (inputEl) {
            inputEl.addEventListener('input', function () {
                var digits = inputEl.value.replace(/\D/g, '');
                digits = digits.replace(/^0+/, '');
                inputEl.value = digits;

                var points = digits ? Number(digits) : 0;
                var isPositiveInteger = Number.isInteger(points) && points > 0;
                var exceedsBalance = isPositiveInteger && points > currentAvailPoints;
                var isValid = isPositiveInteger && !exceedsBalance;

                inputEl.classList.toggle('pts-input-has-error', digits.length > 0 && !isValid);
                if (errorMsgEl) {
                    errorMsgEl.textContent = exceedsBalance
                        ? errorMsgEl.dataset.exceedsMessage
                        : errorMsgEl.dataset.positiveIntegerMessage;
                    errorMsgEl.style.display = digits.length > 0 && !isValid ? 'block' : 'none';
                }
                if (confirmBtnEl) confirmBtnEl.disabled = !isValid;
            });
        }

        if (confirmBtnEl) {
            confirmBtnEl.addEventListener('click', async function () {
                var email = window.PointsTransferCustomer?.email;
                var points = inputEl ? Number(inputEl.value) : 0;
                var isValid = Number.isInteger(points) && points > 0 && points <= currentAvailPoints;

                if (
                    !email ||
                    !currentSourceCustomerId ||
                    !isValid ||
                    !DREAME_LOYALTY_SHOPS.includes(currentSourceStoreId) ||
                    !DREAME_LOYALTY_SHOPS.includes(currentDestinationStoreId) ||
                    !currentDestinationCustomerId ||
                    currentSourceStoreId === currentDestinationStoreId
                ) {
                    return;
                }

                function createRequestId() {
                    return (
                        'points_' +
                        Date.now() +
                        '_' +
                        (
                            window.crypto?.randomUUID?.() ||
                            Math.random().toString(36).slice(2)
                        )
                    );
                }

                async function changeStorePoints(storeId, customerId, pointsChange, note) {
                    var requestId = createRequestId();
                    var response = await fetch(
                        `/apps/loyalty/points?flag=${encodeURIComponent(storeId)}&request_id=${encodeURIComponent(requestId)}`,
                        {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                customer_id: Number(customerId),
                                points_change: Number(pointsChange),
                                external_note: note
                            })
                        }
                    );
                    var result = await response.json().catch(function () { return {}; });

                    if (!response.ok || result.success === false) {
                        throw new Error(
                            result?.error?.message ||
                            result?.message ||
                            `Points update failed for ${storeId}: ${response.status}`
                        );
                    }

                    return result;
                }

                confirmBtnEl.disabled = true;
                confirmBtnEl.textContent = 'Transferring...';
                if (inputEl) inputEl.disabled = true;
                if (errorMsgEl) errorMsgEl.style.display = 'none';

                try {
                    // Step 1: subtract points from the source store.
                    await changeStorePoints(
                        currentSourceStoreId,
                        currentSourceCustomerId,
                        -points,
                        'Points transfer to ' + currentDestinationStoreId
                    );

                    // Step 2 only runs after the source subtraction succeeds.
                    await changeStorePoints(
                        currentDestinationStoreId,
                        currentDestinationCustomerId,
                        points,
                        'Points transfer from ' + currentSourceStoreId
                    );
                    closeModal();
                    await Promise.all([
                        loadStorePoints(email, currentSourceStoreId),
                        loadStorePoints(email, currentDestinationStoreId)
                    ]);
                } catch (error) {
                    console.error('[Points Transfer] Transfer failed:', error);
                    if (errorMsgEl) {
                        errorMsgEl.textContent = error?.message || 'Unable to transfer points. Please try again.';
                        errorMsgEl.style.display = 'block';
                    }
                } finally {
                    confirmBtnEl.textContent = confirmButtonText;
                    if (inputEl) inputEl.disabled = false;

                    if (modalBackdrop.classList.contains('pts-modal-active')) {
                        confirmBtnEl.disabled = !(
                            Number.isInteger(points) &&
                            points > 0 &&
                            points <= currentAvailPoints
                        );
                    }
                }
            });
        }
    });
})();